<template>
    <Dialog :header="'Confirm ' + content + '!'" v-model:visible="DeleteModel" modal
        :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }" :style="{ width: '30vw' }"
        :closable="false">
        <p>{{ 'Do you want to ' + content + ' ?' }}</p>
        <template #footer>
            <AddButton :btnname="$t('btn.yes')" @click="$emit('yes')" />
            <AddButton :btnname="$t('btn.no')" @click="$emit('no')" />
        </template>
    </Dialog>
</template>
<script lang="ts">

import { defineComponent, ref } from 'vue'
export default defineComponent({

    props: {

        DeleteModel: {
            readonly: false,
            type: Boolean,
            default: ref(false),
        },
        content: {
            type: String,
            default: 'Delete'
        }


    },
    setup() {

        return {
        }
    },


    methods: {

    }
})

</script>